import React from 'react';
import { COLORS, Color } from '../../../styles/variables';

interface SpyderSelectedIconProps {
  color?: Color;
}

const SpyderSelectedIcon: React.FC<SpyderSelectedIconProps> = ({ color = COLORS.black }) => (
  <svg width="76" height="38" viewBox="0 0 76 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_816_45081)">
      <path
        d="M20.8199 19.17L44.46 18.06C44.3849 17.668 44.3548 17.2688 44.37 16.87C44.46 16.1 44.46 15.5 45.14 15.5C45.2958 15.4744 45.4551 15.4801 45.6086 15.5167C45.7622 15.5532 45.9069 15.62 46.0344 15.7131C46.1619 15.8061 46.2697 15.9236 46.3513 16.0587C46.433 16.1938 46.4869 16.3438 46.51 16.5C46.5524 16.73 46.6092 16.9571 46.6801 17.18C46.6801 17.35 46.76 17.52 46.85 17.52C48.2865 17.0167 49.7764 16.6811 51.29 16.52C62.48 16.52 69.0601 18.57 69.0601 18.57V19.76C69.5027 20.283 69.8237 20.8978 70 21.56V24.29L70.9399 24.63C71.1 24.8885 71.1865 25.1859 71.1899 25.49C71.1567 26.5571 70.8317 27.5947 70.25 28.49L66.92 29.77L12.08 30.11L4.39001 29.68L4.73999 24.39C4.80724 23.904 4.98929 23.441 5.271 23.0393C5.5527 22.6376 5.92596 22.3088 6.35999 22.08C7.35999 21.31 9.52003 20.88 11.66 20.29C14.614 19.3296 17.6863 18.7811 20.79 18.66L20.8199 19.17Z"
        fill={color}
        stroke={color}
        strokeWidth="0.75"
      />
      <path d="M53.22 28.98L25.92 29.24" stroke="white" strokeWidth="0.75" strokeMiterlimit="10" />
      <path
        d="M24.04 26.86C24.0998 27.9661 23.83 29.0651 23.2651 30.018C22.7002 30.9709 21.8653 31.7347 20.8662 32.2131C19.867 32.6914 18.7486 32.8626 17.6521 32.7052C16.5556 32.5477 15.5304 32.0686 14.7063 31.3284C13.8821 30.5882 13.296 29.6202 13.0221 28.5469C12.7481 27.4735 12.7987 26.343 13.1673 25.2984C13.536 24.2538 14.2061 23.342 15.093 22.6784C15.9799 22.0147 17.0438 21.629 18.15 21.57C19.5087 21.4774 20.852 21.9026 21.91 22.76"
        fill={color}
      />
      <path
        d="M24.04 26.86C24.0998 27.9661 23.83 29.0651 23.2651 30.018C22.7002 30.9709 21.8653 31.7347 20.8662 32.2131C19.867 32.6914 18.7486 32.8626 17.6521 32.7052C16.5556 32.5477 15.5304 32.0686 14.7063 31.3284C13.8821 30.5882 13.296 29.6202 13.0221 28.5469C12.7481 27.4735 12.7987 26.343 13.1673 25.2984C13.536 24.2538 14.2061 23.342 15.093 22.6784C15.9799 22.0147 17.0438 21.629 18.15 21.57C19.5087 21.4774 20.852 21.9026 21.91 22.76"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M65.8101 26.86C65.8495 27.5947 65.7437 28.3301 65.4989 29.024C65.2542 29.7178 64.8751 30.3567 64.3835 30.9041C63.8918 31.4515 63.2971 31.8967 62.6333 32.2143C61.9696 32.5319 61.2498 32.7156 60.515 32.755C59.7803 32.7944 59.045 32.6887 58.3511 32.4439C57.6572 32.1991 57.0183 31.8201 56.4709 31.3284C55.9235 30.8367 55.4783 30.242 55.1607 29.5783C54.8431 28.9145 54.6594 28.1947 54.62 27.46C54.6051 26.9749 54.6352 26.4895 54.71 26.01C54.8535 25.2943 55.1386 24.6146 55.5485 24.0106C55.9583 23.4066 56.4847 22.8906 57.0967 22.4928C57.7087 22.0951 58.3941 21.8236 59.1125 21.6943C59.8308 21.565 60.5678 21.5806 61.2801 21.74C62.1235 21.9322 62.9129 22.3115 63.59 22.85"
        fill={color}
      />
      <path
        d="M65.8101 26.86C65.8495 27.5947 65.7437 28.3301 65.4989 29.024C65.2542 29.7178 64.8751 30.3567 64.3835 30.9041C63.8918 31.4515 63.2971 31.8967 62.6333 32.2143C61.9696 32.5319 61.2498 32.7156 60.515 32.755C59.7803 32.7944 59.045 32.6887 58.3511 32.4439C57.6572 32.1991 57.0183 31.8201 56.4709 31.3284C55.9235 30.8367 55.4783 30.242 55.1607 29.5783C54.8431 28.9145 54.6594 28.1947 54.62 27.46C54.6051 26.9749 54.6352 26.4895 54.71 26.01C54.8535 25.2943 55.1386 24.6146 55.5485 24.0106C55.9583 23.4066 56.4847 22.8906 57.0967 22.4928C57.7087 22.0951 58.3941 21.8236 59.1125 21.6943C59.8308 21.565 60.5678 21.5806 61.2801 21.74C62.1235 21.9322 62.9129 22.3115 63.59 22.85"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M7.04007 23.02C6.79007 23.28 7.04007 24.21 7.04007 24.21H10.2901C10.8901 24.21 11.4 22.42 11.14 22.16C9.72798 22.154 8.33069 22.4471 7.04007 23.02Z"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M70.4301 21.57H68.03L67.26 20.46L69.71 19.78"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M33.35 13.37C27.2 14.56 20.79 18.66 20.79 18.66" stroke={color} strokeWidth="0.75" />
    </g>
    <defs>
      <clipPath id="clip0_816_45081">
        <rect width="67.57" height="20.14" fill="white" transform="translate(4 13)" />
      </clipPath>
    </defs>
  </svg>
);

export default SpyderSelectedIcon;
